import { Reveal } from "@/components/site/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { IMAGES } from "@/i18n";
import { Check } from "lucide-react";

const About = () => {
  const { t } = useLanguage();
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32 bg-[#0B1F33] text-white overflow-hidden">
      <div className="absolute inset-0 blueprint-grid-dark opacity-30" />
      <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left column */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <div className="flex items-center gap-3 mb-5">
                  <span className="h-px w-10 bg-[#B87333]" />
                  <span className="overline text-[#B87333]">{t.about.overline}</span>
                </div>
                <h2 className="font-display font-extrabold tracking-tighter leading-[1.02] text-4xl lg:text-5xl">
                  {t.about.title}
                </h2>
                <p className="mt-6 text-white/70 leading-relaxed">{t.about.text}</p>
              </Reveal>

              <Reveal delay={0.15}>
                <div className="mt-8 overflow-hidden border border-white/10">
                  <img
                    src={IMAGES.about}
                    alt="Struttura in acciaio e gru di cantiere"
                    className="w-full h-64 object-cover grayscale hover:grayscale-0 transition-all duration-700 hover:scale-105"
                  />
                </div>
              </Reveal>
            </div>
          </div>

          {/* Timeline */}
          <div className="lg:col-span-7">
            <div className="relative pl-8">
              <div className="absolute left-0 top-2 bottom-2 w-px bg-white/15" />
              {t.about.timeline.map((e, i) => (
                <Reveal key={e.year + i} delay={i * 0.06} className="relative pb-12 last:pb-0">
                  <span className="absolute -left-8 top-1.5 w-3 h-3 rounded-full bg-[#B87333] ring-4 ring-[#0B1F33]" />
                  <div data-testid={`timeline-item-${i}`}>
                    <span className="font-display text-[#B87333] font-bold text-sm tracking-widest">{e.year}</span>
                    <h3 className="mt-1 font-display text-xl font-bold tracking-tight">{e.title}</h3>
                    <div className="text-white/50 text-xs uppercase tracking-widest mt-1">{e.place}</div>
                    <p className="mt-3 text-white/70 text-sm leading-relaxed max-w-xl">{e.text}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            {/* Credentials */}
            <Reveal className="mt-10 pt-10 border-t border-white/10">
              <h4 className="overline text-white/50 mb-5">{t.about.credentialsTitle}</h4>
              <div className="grid sm:grid-cols-2 gap-x-8 gap-y-3">
                {t.about.credentials.map((c) => (
                  <div key={c} data-testid="credential-item" className="flex items-start gap-3">
                    <Check size={16} className="text-[#B87333] mt-0.5 shrink-0" />
                    <span className="text-white/80 text-sm">{c}</span>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
